import React from "react";

import "./Footer.css";

import footer_logo from "../../image/logo/Logo.png";
import { NavLink } from "react-router-dom";
import { useInView } from "react-intersection-observer";

function Footer() {
  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0,
    delay: 100,
  });

  return (
    <div className={`footer_main ${inView ? "fade-up" : null}`} ref={ref}>
      <div className=" footer-logo">
        <NavLink to="/">
          <img width={100} src={footer_logo} className="footer_logo" />
        </NavLink>
      </div>
      <div className="flex-1">
        <div className="f-2 f-400 footer"> QUICK LINKS</div>
        <div className="footer-section">
          <div className="footer-section-1">
            <NavLink to={"/vision-and-mission"}>
              <div className="f-1-2 fs-6 hover cursor f-500 mt-2 fs-small">
                About HG Educational Institutions
              </div>
            </NavLink>
            <NavLink to={"/nep"}>
              <div className="f-1-2 fs-6 hover cursor f-500 mt-2">
                Academics & Curriculum
              </div>
            </NavLink>
            <a href="https://www.soschildrensvillages.in/about-us/" target="_blank">
                <div className="f-1-2 fs-6 hover cursor f-500 mt-2">
                  SOS Children’s Villages of India
                </div>
              </a>
          </div>
          <div className="footer-section-2">
            <NavLink to={"/house-clubs"}>
              <div className="f-1-2 fs-6 hover cursor f-500 mt-2">
                Beyond Curriculum
              </div>
            </NavLink>
            <NavLink to={"/news"}>
              <div className="f-1-2 fs-6 hover cursor f-500 mt-2">
                News & Media Coverage
              </div>
            </NavLink>
          </div>
          <div className="footer-section-3">
            <NavLink to={"/infrastructure"}>
              <div className="f-1-2 fs-6 hover cursor f-500 mt-2">
                {" "}
                Infrastructure & Facilities
              </div>
            </NavLink>
            <NavLink to={"/contact-us"}>
              <div className="f-1-2 fs-6 hover cursor f-500 mt-2">
                {" "}
                Contact Us
              </div>
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
